import axios from 'axios';
// config
import { HOST_API } from '../config';

// ----------------------------------------------------------------------

const authzHeader = localStorage.getItem('accessToken');

const axiosInstance = axios.create({
  baseURL: HOST_API,
  headers: {
    Authorization: authzHeader,
  },
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
);

export default axiosInstance;
